import { render, staticRenderFns } from "./ColumnsSettings.vue?vue&type=template&id=4b2c7a23"
import script from "./ColumnsSettings.vue?vue&type=script&lang=js"
export * from "./ColumnsSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports